import { Text, Button } from '@user-portal/wikr-components';

import styled, { createGlobalStyle, css } from 'styled-components';

import { responsiveSize } from 'theme/helpers';

import { color } from 'theme/selectors';

export const DarkModeModalStyles = createGlobalStyle<{ isDarkMode?: boolean }>`
    .ReactModalPortal .ReactModal__Overlay {
        overflow: hidden;
    }

    ${({ isDarkMode }) =>
        isDarkMode &&
        css`
            .ReactModalPortal .ReactModal__Content {
                background-color: ${color('on-primary')};
            }

            .ReactModalPortal .ReactModal__Content p {
                color: ${color('surface-default')};
            }

            .ReactModalPortal .ReactModal__Content button p {
                color: ${color('on-primary')};
            }
        `}
`;

export const Container = styled.div`
    padding: ${responsiveSize(24, 84)} ${responsiveSize(16, 56)} ${responsiveSize(16, 56)};
    overflow: hidden;
`;

export const Title = styled(Text)`
    font-size: ${responsiveSize(24, 84)};
    line-height: ${responsiveSize(32, 112)};
    margin-bottom: ${responsiveSize(12, 42)};
`;

export const Subtitle = styled(Text)<{ $mb: boolean }>`
    font-size: ${responsiveSize(16, 56)};
    line-height: ${responsiveSize(24, 84)};
    margin-bottom: ${({ $mb }) => ($mb ? responsiveSize(24, 84) : responsiveSize(16, 56))};
    white-space: pre-line;
`;

export const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    width: ${responsiveSize(32, 132)};
    margin-bottom: ${responsiveSize(20, 72)};
`;

export const StyledButton = styled(Button)`
    padding: ${responsiveSize(20, 72)};
`;

export const ButtonText = styled(Text)`
    font-size: ${responsiveSize(17, 60)};
    line-height: ${responsiveSize(24, 28)};
`;
